import React from 'react';
import Button from '../../../components/ui/Button';

const SocialAuthButtons = ({ onSocialAuth, isLoading }) => {
  const socialProviders = [
    {
      name: 'Google',
      icon: 'Mail',
      label: 'Продолжить с Google'
    },
    {
      name: 'GitHub',
      icon: 'Github',
      label: 'Продолжить с GitHub'
    },
    {
      name: 'VK',
      icon: 'MessageCircle',
      label: 'Продолжить с VK'
    }
  ];

  return (
    <div className="social-auth-section">
      <div className="relative mb-6">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border"></div>
        </div>
        <div className="relative flex justify-center text-xs">
          <span className="bg-card px-3 text-muted-foreground font-caption">
            или войдите через
          </span>
        </div>
      </div>
      <div className="social-buttons space-y-3">
        {socialProviders?.map((provider) => (
          <Button
            key={provider?.name}
            type="button"
            variant="outline"
            fullWidth
            iconName={provider?.icon}
            iconPosition="left"
            onClick={() => onSocialAuth(provider?.name?.toLowerCase())}
            disabled={isLoading}
          >
            {provider?.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default SocialAuthButtons;